import { Image } from "@components/anti/Image"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact, imgUrl, rgbDataURL } from "src/mixins"

export function ServicesContent({ alt, data, locale, gradient, index }) {
  const [trigger, anim] = useScrollAnim("fadeInUp", [0.125, 0.5, 0.75])
  return (
    <section className="py-3 py-md-5 sc-services-content" ref={trigger}>
      {gradient && <div className="cinema-gradient" />}
      <div className="container">
        <div className="row row-5">
          <div className={`col-left col-md-7 mb-4 mb-md-0 ${anim(1)}`}>
            <Image
              src={imgUrl(data?.image_mobile)}
              alt="Image"
              className="img-fluid position-relative d-md-none"
              fill
              priority
              placeholder="blur"
              blurDataURL={rgbDataURL(156, 167, 178)}
            />
            <Image
              src={imgUrl(data?.image_desktop)}
              alt="Image"
              className="img-fluid position-relative d-none d-md-block"
              fill
              priority
              placeholder="blur"
              blurDataURL={rgbDataURL(156, 167, 178)}
            />
          </div>
          <div className={`col-md-5 col-right ${alt ? "order-md-first" : ""}`}>
            <div className="w-md-300px">
              <h2 className={anim(3)}>{data && data[`title_${locale}`]}</h2>
              <div className={`desc ${anim(5)}`}>
                {convertHtmlToReact(data[`description_${locale}`])}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
